<template>
    <div class="editor">
        <div class="header">
            <h2>UML Generator
                <small>Sequence</small>
            </h2>
            <div class="links">
                <a href="#" @click="onDownloadPNGClicked">Download PNG</a>
                <a href="#" @click="onDownloadSVGClicked">Download SVG</a>
            </div>
        </div>
        <div class="panes">
            <Multipane class="vertical-panes">
                <div class="code-pane">
                    <codemirror v-model="value" :options="cmOption"/>
                </div>
                <MultipaneResizer></MultipaneResizer>
                <div ref="codeDiv" @click="onImageClicked" class="diagram-container" v-html="code"></div>
            </Multipane>
        </div>
    </div>
</template>

<script>
import {Multipane, MultipaneResizer} from 'vue-multipane';
import mermaid from "mermaid";
import 'codemirror/mode/markdown/markdown.js';
import {Base64} from "js-base64";

export default {
    name: "Editor",
    data() {
        return {
            value: "#start: User Clicks on the Reminder Button\n" +
                "#if{blue}: is date already in schedule table\n" +
                "    [yes]\n" +
                "    #end: Stop the Process\n" +
                "    [no]\n" +
                "    #box: Insert the date in to schedule table\n" +
                "#end: Done",
            code: '',
            isEditable: true,

            cmOption: {
                tabSize: 4,
                lineNumbers: true,
                line: true,
                styleSelectedText: true,
                matchBrackets: true,
                theme: "monokai",
            }
        };
    },

    mounted() {
        mermaid.initialize({
            theme: "forest"
        });
        mermaid.init();
    },

    methods: {
        codeUpdated(code) {
            try {
                let container = this.$refs.codeDiv;
                container.removeAttribute("data-processed");
                container.innerHTML = code;
                mermaid.init(code, container);
            } catch (ex) {
                return;
            }
        },

        onImageClicked(event) {
            event.stopPropagation();
            event.preventDefault();
        },

        onDownloadSVGClicked(event) {
            event.stopPropagation();
            event.preventDefault();

            const container = this.$refs.codeDiv;
            const linkSource = `data:image/svg+xml;base64,${Base64.encode(
                container.innerHTML
            )}`;
            const downloadLink = document.createElement("a");
            const fileName = "sequence-diagram.svg";

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },

        onDownloadPNGClicked(event) {
            const canvas = document.createElement('canvas');
            const container = this.$refs.codeDiv;
            const svg = document.querySelector('.diagram-container svg');
            const box = svg.getBoundingClientRect();
            canvas.width = box.width;
            canvas.height = box.height;
            const context = canvas.getContext('2d');
            context.fillStyle = "white";
            context.fillRect(0, 0, canvas.width, canvas.height);
            const image = new Image();

            image.onload = function () {
                context.drawImage(image, 0, 0);
                const a = document.createElement('a');
                a.download = 'flow-chart.png';
                a.href = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
                a.click();
            };

            image.src = `data:image/svg+xml;base64,${Base64.encode(container.innerHTML)}`;
            event.stopPropagation();
            event.preventDefault();
            event.target.download = 'sequence-diagram.png';
        }
    },

    watch: {
        value: function () {
            this.codeUpdated(this.value);
        }
    },

    components: {
        Multipane,
        MultipaneResizer
    }
};
</script>

<style lang="scss">

.header {
    align-items: center;
    border-bottom-color: rgb(68, 72, 87);
    border-bottom-style: solid;
    border-bottom-width: 1px;
    box-shadow: none;
    box-sizing: border-box;
    color: rgb(255, 255, 255);
    background-color: #1E1F26;
    display: flex;
    font-family: Lato, "Lucida Grande", "Lucida Sans Unicode", Tahoma, sans-serif;
    font-size: 15px;
    font-weight: 400;
    height: 65px;
    line-height: 22.5px;
    margin: 0;
    padding: 0;
    position: relative;
    z-index: 11;
    -webkit-box-direction: normal;
    justify-content: space-between;

    h2 {
        padding-left: 1.2em;

        small {
            font-size: 0.7em;
        }
    }

    .links {
        padding-right: 1.2em;

        a {
            display: inline-block;
            padding: 5px 10px;
            border-radius: 8px;
            background-color: #0f0e10;
            color: white;
            text-decoration: none;
            margin-right: 0.5em;

            &:active {
                text-decoration: none;
            }
        }
    }
}

.panes {
    height: calc(100vh - 65px);


    .vertical-panes {
        width: 100%;
        height: 100%;

        & > .pane {
            text-align: left;
            padding: 15px;
            overflow: hidden;
            background: #eee;
        }

        & > .pane ~ .pane {
        }

        & > .multipane-resizer {
            margin: 0;
            left: 0;
            position: relative;
            background-color: #333642;

            &:before {
                display: block;
                content: "";
                width: 3px;
                height: 40px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -20px;
                margin-left: -3px;
                border-left: 1px solid #fff;
                border-right: 1px solid #fff;
            }

            &:hover {
                &:before {
                    border-color: #999;
                }
            }
        }

        .code-pane {
            color: #fff;
            min-width: 15%;
            width: 30%;
            max-width: 50%;
            height: 100%;
        }

        .diagram-container {
            width: auto;
            background-color: #eeeeee;
            flex-grow: 1;
            overflow: scroll;


            svg {
                margin: 0 auto;
                width: 100%;
            }
        }

    }
}


.vue-codemirror,
.CodeMirror {
    height: 100% !important;
}

</style>
